let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("14Bg4")).then(() => parcelRequire('8rFLj'));